import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import HelpIcon from '@mui/icons-material/Help';
import {
    Autocomplete,
    Button,
    Chip,
    MenuItem,
    Select,
    Tooltip,
} from "@mui/material";
import ToolBarCommon from "../../../components/common/ToolBarCommon";
import CustomDatePicker from '../../../components/common/CustomDatePicker'
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import { Box } from "@mui/system";
import ReceiptStateSelect from "../../../components/common/ReceiptStateSelect";
import FiscalizationStateSelect from "../../../components/common/FiscalizationStateSelect";
import { CloudDownload } from "@mui/icons-material";
import { CSVDownload, CSVLink } from "react-csv";
import { useSearchParams } from "react-router-dom";

function ToolBar(props) {
    const {
        filter,
        handleFilter,
        selectedPlace,
        handleSelectedPlace,
        parkingPlaces,
        table,
        setTable,
        prepareExportCsv,
    } = props;

    const { t } = useTranslation();
    const [searchParams, setSearchParams] = useSearchParams();
    const [shown, setShown] = React.useState(true);
    const [exportData, setExportData] = React.useState([]);
    const toggleDrawer = (open) => (event) => {
        setShown(!shown);
    };

    const handleTableClick = () => () => {
        setTable(!table);
    }

    return (
        <ToolBarCommon shown={shown} setShown={setShown} title={t("RECEIPTS_LIST")}>
            {!shown && (
                <Grid
                    item
                    xs={11}
                    sx={{
                        display: shown ? "flex" : { xs: "flex", lg: "none" },
                    }}
                ></Grid>
            )}
            <Grid
                xs={6}
                item
                sm={2}
                sx={{ display: shown ? "flex" : { xs: "none", lg: "flex" } }}
            >
                <Autocomplete
                    value={selectedPlace}
                    onChange={(event, newValue) => {
                        handleSelectedPlace(newValue);
                    }}
                    isOptionEqualToValue={(option, value) =>
                        option.value === value.value
                    }
                    filterSelectedOptions
                    id="role"
                    style={{ width: "100%" }}
                    options={parkingPlaces || []}
                    getOptionLabel={(option) => {
                        return option.label;
                    }}
                    renderInput={(params) => (
                        <TextField
                            variant="outlined"
                            {...params}
                            label={t("PARKING_PLACE")}
                            fullWidth
                        />
                    )}
                    renderTags={(value, getTagProps) =>
                        value.map((option, index) => {
                            return (
                                <Chip
                                    style={{
                                        backgroundColor: option.color,
                                        color: "black",
                                    }}
                                    variant="outlined"
                                    label={option.label}
                                    {...getTagProps({ index })}
                                />
                            );
                        })
                    }
                />
            </Grid>

            <Grid
                item
                xs={6}
                sm={1.5}
                sx={{ display: shown ? "flex" : { xs: "none", lg: "flex" } }}
            >
                <CustomDatePicker disablePast={false} date={filter.dateFrom} setDate={handleFilter('dateFrom')} label={t('DATE_FROM')} />
            </Grid>
            <Grid
                item
                xs={6}
                sm={1.5}
                sx={{ display: shown ? "flex" : { xs: "none", lg: "flex" } }}
            >
                <CustomDatePicker disablePast={false} date={filter.dateTo} setDate={handleFilter('dateTo')} label={t('DATE_TO')} />
            </Grid>
            <Grid
                item
                xs={6}
                sm={1.5}
                sx={{ display: shown ? "flex" : { xs: "none", lg: "flex" } }}
            >
                <ReceiptStateSelect fullWidth value={filter.state || ""} onChange={handleFilter('state')} />
            </Grid>
            <Grid
                item
                xs={6}
                sm={1.5}
                sx={{ display: shown ? "flex" : { xs: "none", lg: "flex" } }}
            >
                <FiscalizationStateSelect fullWidth value={filter.fiscalizationState || ""} onChange={handleFilter('fiscalizationState')} />
            </Grid>
            <Grid
                item
                xs={12}
                sm={3.5}
                sx={{ display: shown ? "flex" : { xs: "none", lg: "flex" } }}
            >
                <TextField
                    variant="outlined"
                    type="search"
                    label={t("FILTER_QUERY")}
                    fullWidth
                    value={filter.query || ""}
                    onChange={handleFilter('query')}
                />
                <Box sx={{ display: 'flex', alignItems: 'center', ml: 1 }}>
                    <Tooltip title={t("SEARCH_RECEIPT_TOOLTIP")}><HelpIcon fontSize="small" sx={{ color: "primary.main" }} /></Tooltip>
                </Box>
            </Grid>

            <Grid
                xs={12}
                item
                sm={0.5}
                sx={{ display: shown ? "flex" : { xs: "none", lg: "flex" }, alignSelf: "center" }}
            >
                <Button onClick={handleTableClick()}>
                    <FormatListBulletedIcon />
                </Button>
                <CSVLink
                    data={exportData}
                    asyncOnClick={true}
                    onClick={(event, done) => {
                        setExportData(prepareExportCsv());
                        done(true);
                    }}
                    separator={','}
                    filename='receipts.csv'
                    enclosingCharacter={`"`}
                >
                    <Button><CloudDownload /></Button>
                </CSVLink>
            </Grid>
            {filter.parkingActiveId != undefined &&
                <Grid
                    item
                    xs={12}
                    sm={3}
                    sx={{ display: shown ? "flex" : { xs: "none", lg: "flex" }, alignSelf: "center" }}
                >
                    <Chip label={t("PARKING_ACTIVE_ID") + ": " + filter.parkingActiveId} variant="outlined" onDelete={() => {
                        handleFilter('parkingActiveId')(undefined);
                        setSearchParams((searchParams) => {
                            searchParams.delete('parkingActiveId');
                            return searchParams;
                        });
                    }} />
                </Grid>
            }


        </ToolBarCommon>
    );
}

ToolBar.propTypes = {};

ToolBar.defaultProps = {};

export default ToolBar;
